import { gsapEffects } from './scripts/gsapEffects.js';
import { technoEffect } from './scripts/technoEffect.js';
import { menu } from './scripts/menu.js';
import { three } from './scripts/three.js';

gsapEffects();
technoEffect();
menu();
three();

